export default __webpack_public_path__ + "static/media/Meeting_Place_(Based_On_A_Poem_By_Rumi).30cf68c3.mp3";